<template>
	<div>
		<div v-if="coupon.length == 0" class="container">
			<div class="iv2-coupon__items-null row clearfix">
				<div class="column full">
					<div style="padding: 2rem 0;">
						<h4 class="size-28 text-center" style="font-weight: bold;">{{ $t('coupon.null_title') }}</h4>
						<p class="text-center">{{ $t('coupon.null_summary') }}</p>
					</div>
				</div>
				<div class="column full text-center">
					<span>
						<router-link
							to="/"
							class="theme__main-btn is-btn is-btn-ghost2 is-upper size-18"
							style="border: 0; letter-spacing: 2px; max-width: 100%; width: 300px; padding-top: 15px; padding-bottom: 15px;"
						>{{ $t('coupon.top_button') }}</router-link>
					</span>
				</div>
			</div>
		</div>
		<div v-else>
			<div class="container">
				<div class="spacer height-60"></div>
				<div class="row clearfix">
					<div class="column full">
						<p class="text-pre m-0">{{ $t('coupon.message') }}</p>
						<p class="text-pre m-0"><strong>{{ $t('coupon.do_action') }}</strong></p>
					</div>
				</div>
				<div class="spacer height-80"></div>
			</div>

			<div class="theme__sub-bg">
				<div class="container">
					<div class="spacer height-80"></div>
					<div class="row">
						<div v-for="item in coupon" :key="item.id" class="iv2-coupon-item my-4 col-md-6 col-xl-4">
							<router-link :to="{ name: 'couponDetail', params: { id: item.id }}" class="iv2-coupon-item__link">
								<div class="iv2-coupon-item__img fit-img">
									<picture>
										<source type="image/webp" :srcset="item.image + $t('general.image_webp')">
										<img class="m-0" :src="item.image" :alt="'「' + item.title + '」' + $t('coupon.alt') ">
									</picture>
								</div>

								<div v-if="isAfter(setDatetime(item.usage_end_at), end)" class="iv2-coupon-item__data mt-4">
									<small v-if="item.usage_begin_at !== null" class="iv2-coupon-item__date">{{ $t('coupon.limit') }}：{{ item.usage_begin_at | moment }}〜{{ item.usage_end_at | moment }}</small>
									<small v-else class="iv2-coupon-item__date">{{ $t('coupon.limit_none') }}</small>
								</div>
								<div v-else class="iv2-coupon-item__data mt-4">
									<small class="iv2-coupon-item__date text-danger">{{ $t('coupon.limit_over') }}</small>
								</div>
								<h3 class="iv2-coupon-item__title">{{ item.title }}</h3>
							</router-link>
						</div>
					</div>
					<div class="spacer height-60"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import moment from "moment";
export default {
	props: ["coupon"],

	data() {
		return {
			start: "",
			end: moment().format(),
		};
	},

	methods: {
		isAfter: function (start, end) {
			return moment(start).isAfter(end);
		},

		setDatetime: function (start) {
			return moment(start);
		},
	},

	filters: {
		moment: function (created) {
			return moment(created).format("YYYY年MM月DD日");
		},
	},
};
</script>

<style lang="scss">
.iv2-coupon__items-null {
	padding: 8rem 0;
}

.iv2-coupon-item .iv2-coupon-item__link {
	display: block;
	text-decoration: none;

	&:hover .iv2-coupon-item__img {
		opacity: 0.7;
	}

	.iv2-coupon-item__img {
		height: 200px;
		-webkit-transition: 0.3s;
		transition: 0.3s;
	}

	.iv2-coupon-item__title {
		font-size: 1.1rem;
		font-weight: bold;
	}

	.iv2-coupon-item__new {
		color: #a83535;
	}

	.iv2-coupon-item__label {
		width: 100%;
		text-align: center;
		border: 1px solid;
	}
}
</style>